import { useState, useRef, useEffect, forwardRef, useImperativeHandle } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import { useSelector, useDispatch } from 'react-redux';
import strFunc from '@/lib/lyg/string';
import getXcolumnJson from "./xcolumn/list";
import SearchArea from "./area/search";
import UseList from "./area/list";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import CoolenWordGroupResultPopup from "@/pages/comp/coolen/word_group/result/popup/group_result";

const BookUseListArea = forwardRef((props: any, ref) => {
  let myProps = {
    s_subject: "",
    callBackRefreshData: (inData: any) => { },
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const xColumnArr = getXcolumnJson();
  const [info_arr, set_info_arr] = useState<any[]>([]);
  const [countInfo, setCountInfo] = useState({ "tot": 0 });
  const [textbook_arr, set_textbook_arr] = useState<any[]>([]);

  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    s_stu_mcomp_seq: "",
    s_stu_seq: "",
    s_subject: myProps.s_subject,
    order_id: "a_re_start_date DESC",
    // s_addon_textbook: "1",
    s_in_now_period: "1",
    s_addon_use_det: "1",
  });

  const [popupData, setPopupData] = useState({
    isOpen: false,
    sort: "word_group_result",
    title: "결과",
    g_par_id: "",
    g_par_seq: "",
    stu_seq: "",
    width: "100%",
    height: "100%",
  });

  useEffect(() => {

  }, []);

  useImperativeHandle(ref, () => ({
    // 부모 컴포넌트에서 사용할 함수를 선언
    setInitData
  }));

  const setInitData = (inData: any) => {
    let opt_obj = {
      stu_seq: "",
      ...inData
    };

    list({
      s_stu_seq: opt_obj.stu_seq
    });
  };

  const list = (inData: any) => {
    let change_list_opt = {
      ...listOpt,
      ...inData
    };
    change_list_opt.s_stu_mcomp_seq = user.comp_seq;

    if (strFunc.is_empty(change_list_opt.s_stu_mcomp_seq)) {
      return false;
    }
    if (strFunc.is_empty(change_list_opt.s_stu_seq)) {
      return false;
    }
    if (strFunc.is_empty(user.comp_seq)) {
      return false;
    }
    setListOpt(change_list_opt);

    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/textbook/use/list', change_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_info_arr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);

          let textbook_seq_arr: any[] = [];
          for (let i = 0; i < response.data["data"]["info_arr"].length; i++) {
            let row = response.data["data"]["info_arr"][i];
            if (!strFunc.is_empty(row.a_book_seq)) {
              textbook_seq_arr.push(row.a_book_seq);
            }
          }
          get_textbook_arr_by_ajax({ textbook_seq_arr: textbook_seq_arr });

        } else {

        }
      });
  };

  const get_textbook_arr_by_ajax = (inData: any) => {
    let opt_obj = {
      textbook_seq_arr: [],
      ...inData
    };
    if (opt_obj.textbook_seq_arr.length === 0) {
      return false;
    }

    let form_json_data: any = {
      s_seq: opt_obj.textbook_seq_arr,
      s_addon_section: "1",
      s_addon_study: "1",
      s_addon_study_word: "1",
      // s_addon_product: "1",
      order_id: "a_subject DESC",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/textbook/textbook/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_textbook_arr(response.data["data"]["info_arr"]);
        } else {

        }
      });
  };

  const update_use_main_state_by_ajax = (inData: any) => {
    let opt_obj = {
      "mcomp_seq": user.comp_seq,
      "textbook_seq": "",
      "stu_seq": "",
      "state_sort": "main",//main,sub
      "state": "1",
      "is_use_need_period": "",
      "is_use_period": "",
      "is_apply_daily_report": "1",
      ...inData
    };

    if (opt_obj.mcomp_seq == "") {
      alert("회사 정보가 없습니다.");
      return;
    }
    if (opt_obj.textbook_seq == "") {
      alert("교재 정보가 없습니다.");
      return;
    }
    if (opt_obj.stu_seq == "") {
      alert("학생 정보가 없습니다.");
      return;
    }
    let confirm_msg = "학습상태를 메인교재로 변경하시겠습니까?";
    if (opt_obj.state == "") {
      confirm_msg = "학습상태를 메인교재에서 해제하시겠습니까?";
    }
    if (!confirm(confirm_msg)) {
      return;
    }

    let form_json_data: any = {
      ...opt_obj
    };

    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/textbook/use/update_use_main_state', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          list({});
          //myProps.callBackRefreshData();
        } else {
          alert("학습상태 변경에 실패하였습니다." + response.data["msg"]);
        }
      });
  };

  const update_textbook_use_by_ajax = (inData: any) => {
    let opt_obj = {
      up_use_arr: [],
      ...inData
    };
    let up_use_arr = opt_obj.up_use_arr;
    if (up_use_arr.length == 0) {
      return false;
    }
    for (let i = 0; i < up_use_arr.length; i++) {
      let row = up_use_arr[i];
      if (strFunc.is_empty(row.a_book_seq) || strFunc.is_empty(row.a_stu_mcomp_seq)
        || strFunc.is_empty(row.a_stu_seq)) {
        return false;
      }
    }

    let form_json_data: any = {
      data_arr: opt_obj.up_use_arr
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/textbook/use/write', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          list({});
          //myProps.callBackRefreshData();
        } else {
          alert("수정에 실패하였습니다." + response.data["msg"]);
        }
      });
  };

  const open_word_group_result_popup = (inData: any) => {
    let opt_obj = {
      g_par_id: "",
      g_par_seq: "",
      stu_seq: "",
      ...inData
    };

    if (strFunc.is_empty(opt_obj.g_par_id)) {
      alert("그룹 구분이 없습니다.");
      return;
    }
    if (strFunc.is_empty(opt_obj.g_par_seq)) {
      alert("그룹 키가 없습니다.");
      return;
    }
    if (strFunc.is_empty(opt_obj.stu_seq)) {
      alert("학생 키가 없습니다.");
      return;
    }

    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "word_group_result",
      title: "결과보기",
      g_par_id: opt_obj.g_par_id,
      g_par_seq: opt_obj.g_par_seq,
      stu_seq: opt_obj.stu_seq
    });
  }

  return (
    <div>
      <SearchArea
        listOpt={listOpt}
        setListOpt={setListOpt}
        list={list}
      ></SearchArea>
      <div className='mt-2'>
        <UseList
          xColumnArr={xColumnArr}
          info_arr={info_arr}
          textbook_arr={textbook_arr}
          update_use_main_state_by_ajax={update_use_main_state_by_ajax}
          update_textbook_use_by_ajax={update_textbook_use_by_ajax}
          open_word_group_result_popup={open_word_group_result_popup}
        ></UseList>
        <Paging now_page={listOpt.now_page}
          num_per_page={listOpt.num_per_page}
          total_rec={countInfo.tot}
          onChangePage={(now_page: number) => { list({ now_page: now_page }); }}
          onChangeNumPerPage={(num_per_page: number) => { list({ num_per_page: num_per_page, now_page: 1 }); }}></Paging>
      </div>
      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} >
          {popupData.sort === "word_group_result" &&
            <CoolenWordGroupResultPopup
              g_par_id={popupData.g_par_id}
              g_par_seq={popupData.g_par_seq}
              stu_seq={popupData.stu_seq}
              callBackData={() => { }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></CoolenWordGroupResultPopup>
          }
        </LayerPopup>
      }
    </div>
  );
});
export default BookUseListArea;